import { NOTIFICATION_TYPES } from '../redux/notification/notification.types';

/**
 * Para onde o clique numa notificação leva.
 *
 * ## Por que isto saiu de dentro do sininho
 *
 * O destino era um `switch` com um `case` por tipo e `default: break` -- e o
 * `break` era o defeito. Dois tipos caíam nele e o clique **não fazia nada**:
 *
 * - `calendar_reminder`, o lembrete da agenda (item 12). A api manda
 *   `route: '/agenda'`, e era ignorado.
 * - `ANNOUNCEMENT`, os avisos do mural. A api manda
 *   `route: '/mural-avisos'`, e era ignorado do mesmo jeito.
 *
 * Então o conserto não é acrescentar dois `case`: é **honrar o `route` que a
 * api já manda**. Assim o próximo tipo que ela criar com rota já funciona sem
 * ninguém mexer nesta tela -- e foi exatamente o "um `case` por tipo" que
 * produziu o defeito.
 *
 * Os tipos que já tinham `case` continuam com ele, porque o destino deles não
 * vem de `route`: é montado a partir do `ticket_id`/`room_id` da notificação.
 *
 * @param {object} notificacao
 * @returns {{rota: string, estado?: object}|null} `null` = não há para onde ir
 */
export const destinoDaNotificacao = (notificacao) => {
    const dados = notificacao?.data || {};
    const tipo = dados.type || notificacao?.type;
    const roomId = notificacao?.room_id ?? dados.room_id;
    const ticketId = dados.ticket_id;

    switch (tipo) {
        case NOTIFICATION_TYPES.NEW_TICKET_ASSIGNED:
        case NOTIFICATION_TYPES.TICKET_UPDATED:
        case NOTIFICATION_TYPES.CHAT_CLOSED_BY_CLIENT:
            return { rota: ticketId ? `/ticket/${ticketId}` : '/ticket' };

        case NOTIFICATION_TYPES.NEW_MESSAGE:
        case NOTIFICATION_TYPES.FILE_RECEIVED:
        case NOTIFICATION_TYPES.TRANSFER:
            return { rota: '/chat', estado: roomId ? { roomId } : undefined };

        case NOTIFICATION_TYPES.NEW_CLIENT:
            return { rota: '/painel-atendimentos', estado: roomId ? { roomId } : undefined };

        default:
            // Só rota INTERNA. `startsWith('/')` recusa `http://` e
            // `//outro.site`, que num `history.push` daria navegação quebrada
            // dentro do app -- e impede que um valor vindo dos dados da
            // notificação mande o operador para fora do sistema.
            if (typeof dados.route === 'string' && dados.route.startsWith('/') && !dados.route.startsWith('//')) {
                return { rota: dados.route };
            }
            return null;
    }
};

export default destinoDaNotificacao;
